const Subjects = [
    '-',
    'General Inquiry',
    'Sales',
    'Support',
    'Becoming an API provider',
    'Other'
];

export default Subjects;


// WEBPACK FOOTER //
// ./src/components/Contact/Subjects.ts